<template>
  <div class="summary-details">
    <div class="filter-container">
      <div v-if="$store.getters.isPii" class="tips"><span><svg-icon icon-class="icon-font-warning" style="color: #3855F1;" /></span>{{ $t('tips.current_time_zone') }}</div>
      <div class="right">
        <span class="transTime">{{ $t('components.date') }}:</span>
        <el-date-picker
          v-model="search.times"
          class="picker"
          size="small"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="~"
          :start-placeholder="$t('components.start_date')"
          :end-placeholder="$t('components.end_date')"
        />
        <!-- 查询 -->
        <el-button class="search-btn" size="small" type="primary" icon="el-icon-search" @click="balanceSummary">{{ $t('components.search') }}</el-button>
      </div>
    </div>
    <div class="tableContainer">
      <!-- 列表 -->
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
        class="tableContainer"
      >
        <el-table-column :label="$t('components.date')" align="center" min-width="105">
          <template slot-scope="scope">
            <span>{{ scope.row.statistics_date }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('data.loan_amount')" prop="payout_amount" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.payout_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.loan_fee')" prop="payout_fee" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.payout_fee | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.postpone_amount')" align="center" min-width="90">
          <template slot-scope="scope">
            <span>{{ scope.row.postpone_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.real_time_settlement_amount')" align="center" min-width="90">
          <template slot-scope="scope">
            <span>{{ scope.row.real_settlement_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" min-width="95">
          <template slot="header">
            {{ $t('data.refund_amount') }}
            <el-tooltip placement="top">
              <div slot="content">
                <span> {{ $t('tips.refund_amount_tip') }}</span> <br>
              </div>
              <span> <svg-icon icon-class="icon-font-question" class="icon-question" /></span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.payment_refund_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.refund_fee')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.refund_fee | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.refund_amount_fail')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.payment_refund_fail_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.refund_failed_fee')" align="center" min-width="90">
          <template slot-scope="scope">
            <span>{{ scope.row.refund_failed_fee | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.card_verification_fee')" align="center" min-width="90">
          <template slot-scope="scope">
            <span>{{ scope.row.card_validation_fee | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.card_verification_failed_fee_refund')" align="center" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.card_validation_refund_fee | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.frozen_amount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.frozen_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.unfrozen_amount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.unfrozen_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.top_up')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.deposit | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.cash_out')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.cash_out | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.cashout_fail')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.fail_withdraw_refund_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="$store.getters.isID || $store.getters.isPii" :label="$t('map.balance_type_31')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.split_payment_out | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="$store.getters.isID || $store.getters.isPii" :label="$t('map.balance_type_34')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.split_payment_return_in | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="$store.getters.isID || $store.getters.isPii" :label="$t('map.balance_type_32')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.split_payment_in | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="$store.getters.isID || $store.getters.isPii" :label="$t('map.balance_type_33')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.split_payment_return_out | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="$store.getters.isID" :label="$t('data.transfer')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transfer | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="hasReverse" :label="$t('data.reverse')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.reverse_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.abnormal_adjustment_credit_balance')" align="center" min-width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.abnormal_adjustment_credit | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.abnormal_adjustment_credit_frozen')" align="center" min-width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.frozen_abnormal_adjustment_credit | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.abnormal_adjustment_debit_balance')" align="center" min-width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.abnormal_adjustment_debit | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.abnormal_adjustment_debit_frozen')" align="center" min-width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.frozen_abnormal_adjustment_debit | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.frozen_amount_balance')" align="center">
          <template slot-scope="scope">
            {{ scope.row.frozen_balance | toDivideWithDot }}
          </template>
        </el-table-column>

        <template v-if="$store.getters.isOpenFXFunction">
          <el-table-column :label="$t('map.balance_type_23')" prop="fx_transfer_out_amount" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.fx_transfer_out_amount | toDivideWithDot }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('map.balance_type_24')" prop="fx_transfer_in_amount" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.fx_transfer_in_amount | toDivideWithDot }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('map.balance_type_25')" prop="fx_reversal_transfer_out_amount" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.fx_reversal_transfer_out_amount | toDivideWithDot }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('map.balance_type_26')" prop="fx_reversal_transfer_in_amount" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.fx_reversal_transfer_in_amount | toDivideWithDot }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('data.fx_transfer_out_fee')" prop="fx_transfer_out_fee" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.fx_transfer_out_fee | toDivideWithDot }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('data.fx_reversal_transfer_in_fee')" prop="fx_reversal_transfer_in_fee" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.fx_reversal_transfer_in_fee | toDivideWithDot }}</span>
            </template>
          </el-table-column>

        </template>

        <el-table-column :label="$t('map.balance_type_35')" align="center">
          <template slot-scope="scope">
            {{ scope.row.settlement_advance_fee | toDivideWithDot }}
          </template>
        </el-table-column>

        <el-table-column v-if="$store.getters.nsdsStatus && isHkCountry" :label="$t('map.balance_type_28')" align="center">
          <template slot-scope="scope">
            {{ scope.row.nsds_charge_amount | toDivideWithDot }}
          </template>
        </el-table-column>

        <el-table-column v-if="$store.getters.nsdsStatus" :label="$t('map.balance_type_38')" align="center">
          <template slot-scope="scope">
            {{ scope.row.nsds_deduction_amount | toDivideWithDot }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.balance')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.balance | toDivideWithDot }}</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div>
    </div>

  </div>
</template>

<script>

import { fetchBalanceSummaryDetail } from '@/api/settlement/settlement'
import { appointDate } from '@/utils/index.js'
import { filterEmptyAttr } from '@/utils/common'
export default {
  name: 'Summary_Details',
  components: {
    Paginator: () => import('@/views/components/Paginator')
  },
  data() {
    return {
      search: {
        times: [appointDate(-3), appointDate()]
      },
      tableData: [],
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      }
    }
  },
  computed: {
    isHkCountry() {
      const countryCode = this.$store.getters.curCountry && this.$store.getters.curCountry.country_code
      return /^HK($|-)/.test(countryCode || '')
    },
    hasReverse() {
      let flag = false
      const list = this.tableData || []
      list.forEach(item => {
        if (item.reverse_amount && item.reverse_amount !== '0') {
          flag = true
        }
      })
      return flag
    }
  },
  created() {
    this.balanceSummary()
  },
  methods: {
    balanceSummary(otherParams) {
      const params = this.getParams(otherParams)
      this.listLoading = true
      fetchBalanceSummaryDetail(params).then(res => {
        const { total, list = [], current } = res.data
        this.listQuery.total = total
        this.listQuery.page = params.page ? params.page : 1
        this.tableData = list
      }).finally(() => {
        this.listLoading = false
      })
    },

    getParams(otherParams = {}) {
      const { times = [] } = this.search
      let params = { start_date: times && times[0], end_date: times && times[1], ...otherParams }
      params = filterEmptyAttr(params)
      return params
    },

    onClickPaginator() {
      this.balanceSummary(this.listQuery)
    }
  }
}
</script>

<style lang="scss" scoped>
.summary-details{
   background-color: #fff;
   .transTime{
      display: inline-block;
      padding: 0 20px 10px 0;
      font-size: 14px;
      font-weight: 500;  font-family: 'Inter-Medium';
  }
  .filter-container{
    margin-top: 14px;
    margin-bottom: 32px;
    text-align: right;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .tips{
      text-align: left;
      padding-right: 40px;
      border-radius: 4px;
      border: 1px solid #D3D7DF;
      padding: 10px 12px;
      color: #7A869E;
      width: max-content;
      margin-right: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      span{
        padding-right: 11px;
      }
    }
    .right{
      min-width: max-content;
    }
  }
  .search-frame {
    width: 160px;
    margin-right: 5px;
  }
  .picker{
    margin-right: 10px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .status{
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
 .mb-10{
    margin-bottom: 10px;
  }
}

</style>
